/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { CountryCode } from "../enums";
export const homeOfficeSchema = z.object({
  USHomeOffice: z.boolean(),
  australiaHomeOffice: z.boolean(),
  categories: z.array(z.string()).nullish(),
  countryCode: z.nativeEnum(CountryCode).nullish(),
  createdAt: z.string().datetime().nullish(),
  defaultTimezone: z.string().nullish(),
  id: z.string().uuid(),
  maxDailyHours: z.number().int(),
  maxHours: z.number().int(),
  name: z.string(),
  updatedAt: z.string().datetime().nullish(),
});

export type HomeOffice = z.infer<typeof homeOfficeSchema>;
